// removed by extract-text-webpack-plugin
module.exports = {"element-container":"toolbox-element__element-container___VcS22","elementContainer":"toolbox-element__element-container___VcS22","element":"toolbox-element__element___mDIxQ"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/toolbox-element.css
// module id = 798
// module chunks = 0